module.exports = __webpack_public_path__ + "img/double-left.5b2c82b7.svg";